// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"18583f23","511":"cfa70e48","752":"3bb38d16","970":"5a7deb84"}[chunkId] + ".chunk.js";
};